import React from "react";
import {
  SEO,
  Image,
  MarkdownContent,
  BasicCarousel,
  componentIterator,
  PaginatedGrid,
  VideoPlayer,
  Section,
  FishermanHeader,
  ReviewV2,
  DynamicForm,
} from "@bluefin/components";
import { Grid, Segment } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import {
  getComponentFiles,
  getComponentContentNodeContent,
  getComponentConfigurationData,
} from "../utils/utils";
import "../style/r-u-n-w-a-y-bridal-couture.css";

export default class RUNWAYBridalCouturePage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const {
      fishermanBusiness,
      fishermanBusinessWebsitePage,
      lhnpdmkmlhomfphgkdngkaonnbjfdhjjlhnp,
    } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          title={fishermanBusinessWebsitePage.seoTitle}
          description={fishermanBusinessWebsitePage.description}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
          ogUrl={
            "https://www.runwaysalonbeautybar.com/r-u-n-w-a-y-bridal-couture/"
          }
        />
        <Grid
          className={"custom-page-bridal custom-page-grid"}
          style={{}}
          stackable={true}
        >
          <Grid.Row
            className={"dpghgddngonbedia full-width"}
            style={{ padding: 16 }}
            columns={1}
          >
            <Grid.Column
              className={"mnckcmgeginhemld"}
              style={{ padding: 16 }}
              textAlign={"center"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <Image
                  className={"image-block"}
                  style={{ minHeight: "600px" }}
                  src={getComponentFiles({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "Image",
                    componentIdentifier: "bb5c731f-99a9-437e-9bb1-80c4785c3ae9",
                    numToSelect: 1,
                  })}
                  background={true}
                >
                  <MarkdownContent
                    className={"text-block"}
                    style={{
                      top: 0,
                      left: 0,
                      color: "#FFFFFF",
                      right: 0,
                      bottom: 0,
                      display: "flex",
                      padding: "16px",
                      position: "absolute",
                      overflowY: "scroll",
                      alignItems: "center",
                      background: "rgba(0,0,0,0.62)",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                    content={getComponentContentNodeContent({
                      components: fishermanBusinessWebsitePage.components,
                      componentName: "MarkdownContent",
                      componentId: "1ccd2e2c-d0f6-447d-bb2c-950bf6218cb0",
                      defaultValue: "",
                    })}
                  />
                </Image>
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"mgkannoddamfekke"}
            style={{ padding: 16 }}
            columns={2}
          >
            <Grid.Column className={"liiccpkonjkgealk"} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <Image
                  className={"image-block"}
                  style={{
                    maxHeight: "600px",
                    minHeight: "240px",
                    objectFit: "contain",
                  }}
                  src={getComponentFiles({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "Image",
                    componentIdentifier: "d4b489a0-32f1-4eeb-bf1e-b7fc2f4959b8",
                    numToSelect: 1,
                  })}
                  background={false}
                />
              </Segment>
            </Grid.Column>
            <Grid.Column
              className={"ijobbhafbmppebch"}
              style={{ padding: 16 }}
              textAlign={"left"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "bea63f20-12fa-4d19-9c20-1cda2d89f415",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"bohbmmbimkhiemlk"}
            style={{ padding: 16 }}
            textAlign={"center"}
            verticalAlign={"middle"}
          >
            <Grid.Column
              className={"nfbjggnfcdcnedik"}
              style={{ padding: 16 }}
              width={10}
              textAlign={"center"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "67868254-db46-409f-8ab3-23197db3c7cd",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"flioaighffepeabo"}
            style={{ padding: 16 }}
            textAlign={"center"}
            verticalAlign={"middle"}
          >
            <Grid.Column
              className={"ajkdnlebaoboelel"}
              style={{ padding: 16 }}
              width={16}
              textAlign={"center"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "33366ffc-e1ec-40c8-bd79-734ad8eaae7f",
                    defaultValue: "",
                  })}
                />
              </Segment>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <BasicCarousel
                  className={"image-block"}
                  style={{}}
                  items={componentIterator({
                    iterator: getComponentFiles({
                      components: fishermanBusinessWebsitePage.components,
                      componentName: "BasicCarousel",
                      componentIdentifier:
                        "3de0d737-e86c-4b2f-b638-b1a2ac3debf1",
                    }),
                    component: <Image className={"image"} />,
                    propMap: { src: "__all__" },
                  })}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"amljnmcaejiaelkl"}
            style={{ padding: 16 }}
            columns={1}
          >
            <Grid.Column className={"gimdfomagdffeaka"} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <PaginatedGrid
                  className={"image-block"}
                  style={{}}
                  columns={3}
                  rows={3}
                  mobile={{ rows: 4, columns: 2, stackable: false }}
                  items={componentIterator({
                    iterator: getComponentFiles({
                      components: fishermanBusinessWebsitePage.components,
                      componentName: "PaginatedGrid",
                      componentIdentifier:
                        "2552a50e-fcdf-476f-8c26-9d717670314a",
                    }),
                    component: (
                      <Image
                        background={true}
                        className={"gallery-image-item"}
                      />
                    ),
                    propMap: { src: "__all__" },
                  })}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"jedfdlceccdpecjj"}
            style={{ padding: 16 }}
            textAlign={"center"}
          >
            <Grid.Column
              className={"nbeihbcpgiecebni"}
              style={{ padding: 16 }}
              width={7}
              textAlign={"center"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <VideoPlayer
                  className={"video-block"}
                  style={{}}
                  url={getComponentConfigurationData({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "VideoPlayer",
                    componentIdentifier: "6c39dd6b-5949-44fd-b3c5-3a1413c6a100",
                    dataPath: "data.video.url",
                  })}
                  videoId={getComponentConfigurationData({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "VideoPlayer",
                    componentIdentifier: "6c39dd6b-5949-44fd-b3c5-3a1413c6a100",
                    dataPath: "data.video.videoId",
                  })}
                  source={getComponentConfigurationData({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "VideoPlayer",
                    componentIdentifier: "6c39dd6b-5949-44fd-b3c5-3a1413c6a100",
                    dataPath: "data.video.source",
                  })}
                  placeholder={getComponentConfigurationData({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "VideoPlayer",
                    componentIdentifier: "6c39dd6b-5949-44fd-b3c5-3a1413c6a100",
                    dataPath: "data.video.placeholder",
                  })}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"jjckpjnakeahefal"}
            style={{ padding: 16 }}
            columns={1}
          >
            <Grid.Column className={"kigioceoejefenma"} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__053f1ffa-7568-4c28-87f8-925b3e7fc496"}
                >
                  <div className={"home-page"}>
                    <Section className={"reviews-section"}>
                      <Image
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/7ddfa2ae-b8a8-470f-803c-2b27c413e9a8/652F7956-FBCE-43D4-BA9D-36257C68059D.png"
                        }
                      >
                        <FishermanHeader
                          as={"h2"}
                          content={"Client Experiences"}
                        />
                        <BasicCarousel
                          size={1}
                          displayIndicators={false}
                          stepSize={1}
                          autoScroll={false}
                          leftArrowIcon={"arrow-left"}
                          rightArrowIcon={"arrow-right"}
                          displayPlayPauseButton={false}
                          slide={true}
                          items={[
                            <ReviewV2 key={"1"}>
                              <ReviewV2.Text
                                charLimit={800}
                                charLimit={800}
                                text={
                                  "Runway is the best salon and service around. Diana and her crew, in salon or traveling, always give you an incredible experience. For a bride and bridal party, the professional stylists are kind, fast, talented, and help make the big morning memorable. What is also amazing about runway is that anyone you go to you get high quality service. The consistency is always there! Lastly, they make you look beyond beautiful and your hair and makeup truly reflects what you want and lasts throughout the day. Thanks, Runway!"
                                }
                              />
                              <ReviewV2.Line>
                                <ReviewV2.Rating rating={"5"} />
                              </ReviewV2.Line>
                              <ReviewV2.Line>
                                <ReviewV2.Author author={"Jessica Kaljaj"} />
                                <ReviewV2.Source source={""} link={""} />
                              </ReviewV2.Line>
                            </ReviewV2>,
                            <ReviewV2 key={"2"}>
                              <ReviewV2.Text
                                charLimit={800}
                                charLimit={800}
                                text={
                                  "I had Runway do my bridal hair and makeup on my wedding day, as well as my bridesmaids, flower girl, and mothers and they were PHENOMENAL!! Natalie did my hair and it was my dream look, I cannot thank her enough. She is the best. Ashley did my makeup and it was outstanding, it lasted the entire day (over 17 hours!) and was exactly what I was looking for. They both made me look like a princess on my big day, I can't thank them enough!! All of the ladies at the salon are so incredibly kind, and they were amazing with all of my wedding party! Everyone looked outstanding! They all had nothing but good things to say. Thank you Runway, I will definitely be using you for all my makeup and hair needs!!"
                                }
                              />
                              <ReviewV2.Line>
                                <ReviewV2.Rating rating={"5"} />
                              </ReviewV2.Line>
                              <ReviewV2.Line>
                                <ReviewV2.Author author={"Rebecca Snyder"} />
                                <ReviewV2.Source source={""} link={""} />
                              </ReviewV2.Line>
                            </ReviewV2>,
                            <ReviewV2 key={"3"}>
                              <ReviewV2.Text
                                charLimit={800}
                                charLimit={800}
                                text={
                                  "I cannot say enough great things about Sara for makeup! She is hands down the best makeup artist in the area. I've had the pleasure of working with her multiple times over the last few years - for weddings, special events, professional photos, and even my own wedding (for myself and my whole bridal party) - and she never fails to impress. Her talent is unmatched and she always makes her clients look and feel beautiful! She is professional, detailed, efficient, and the absolute sweetest person! I trust her completely with my look every time, and I always leave with the makeup I wanted/envisioned. Sara is the best and I am so glad to have found her!"
                                }
                              />
                              <ReviewV2.Line>
                                <ReviewV2.Rating rating={"5"} />
                              </ReviewV2.Line>
                              <ReviewV2.Line>
                                <ReviewV2.Author author={"Samantha Riedy"} />
                                <ReviewV2.Source source={""} link={""} />
                              </ReviewV2.Line>
                            </ReviewV2>,
                          ]}
                        />
                      </Image>
                    </Section>
                  </div>
                </React.Fragment>
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"fbklmfekedabenab"}
            style={{ padding: 16 }}
            textAlign={"center"}
            verticalAlign={"middle"}
            columns={1}
          >
            <Grid.Column className={"jmpjidlblhalehlf"} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "b9235cab-f92b-49f7-85e3-3bf307bf18de",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"ojeeoddjmckiepdi"}
            style={{ padding: 16 }}
            columns={1}
          >
            <Grid.Column className={"gfjpllgnoolpehga"} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <PaginatedGrid
                  className={"image-block"}
                  style={{}}
                  columns={3}
                  rows={3}
                  mobile={{ rows: 4, columns: 2, stackable: false }}
                  items={componentIterator({
                    iterator: getComponentFiles({
                      components: fishermanBusinessWebsitePage.components,
                      componentName: "PaginatedGrid",
                      componentIdentifier:
                        "ef8eb6cd-21fe-4786-82ba-17d39c9148d5",
                    }),
                    component: (
                      <Image
                        background={true}
                        className={"gallery-image-item"}
                      />
                    ),
                    propMap: { src: "__all__" },
                  })}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"phipbakihlnkeglb"}
            style={{ padding: 16 }}
            textAlign={"justified"}
          >
            <Grid.Column
              className={"nehhckefnjheecbc"}
              style={{ padding: 16 }}
              width={10}
              textAlign={"left"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <DynamicForm
                  className={""}
                  style={{}}
                  businessId={2794}
                  businessInfoId={7940}
                  websiteId={9560}
                  locationId={3062}
                  componentConfigurationId={189419}
                  header={lhnpdmkmlhomfphgkdngkaonnbjfdhjjlhnp.data.header}
                  fields={
                    lhnpdmkmlhomfphgkdngkaonnbjfdhjjlhnp.data.dynamicFormFields
                  }
                  consentSettings={
                    lhnpdmkmlhomfphgkdngkaonnbjfdhjjlhnp.data.consentSettings
                  }
                />
              </Segment>
            </Grid.Column>
            <Grid.Column
              className={"mkjoieggedlcekcp"}
              style={{ padding: 16 }}
              width={6}
              textAlign={"center"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <VideoPlayer
                  className={"video-block"}
                  style={{}}
                  url={getComponentConfigurationData({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "VideoPlayer",
                    componentIdentifier: "710f2aaf-766d-439b-a542-555ceb166949",
                    dataPath: "data.video.url",
                  })}
                  videoId={getComponentConfigurationData({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "VideoPlayer",
                    componentIdentifier: "710f2aaf-766d-439b-a542-555ceb166949",
                    dataPath: "data.video.videoId",
                  })}
                  source={getComponentConfigurationData({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "VideoPlayer",
                    componentIdentifier: "710f2aaf-766d-439b-a542-555ceb166949",
                    dataPath: "data.video.source",
                  })}
                  placeholder={getComponentConfigurationData({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "VideoPlayer",
                    componentIdentifier: "710f2aaf-766d-439b-a542-555ceb166949",
                    dataPath: "data.video.placeholder",
                  })}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
    }
    fishermanBusinessWebsitePage(_id: { eq: 36772 }) {
      title
      seoTitle
      description
      components {
        files {
          file
          altText
          gatsbyFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
        order
        fastId
        componentIdentifier
        contentNodes {
          content
        }
        data {
          video {
            url
            source
            videoId
            placeholder
          }
        }
      }
    }
    lhnpdmkmlhomfphgkdngkaonnbjfdhjjlhnp: fishermanWebsiteComponent(
      fastId: { eq: "CustomForm" }
      componentIdentifier: { eq: "39acd412-5df9-4477-9d46-e860ea4fd742" }
    ) {
      data {
        header
        dynamicFormFields {
          name
          label
          style {
            color
            marginTop
            marginBottom
          }
          content
          options {
            label
            value
          }
          required
          inputType
          widgetType
          placeholder
          sendEmailToSelectedLocation
        }
        consentSettings {
          show
          required
        }
      }
    }
  }
`;
